export default __webpack_public_path__ + "static/media/bear_cat.767e331a.png";